import type { ApiEnvelope } from '../types';

export class ApiError extends Error {
  constructor(message: string, public readonly status: number, public readonly errors?: Record<string,string[]>) { super(message); }
}
const baseUrl=(import.meta.env.VITE_API_URL||'/api/v1').replace(/\/$/,'');
let unauthorizedHandler:(()=>void)|undefined;
export const setUnauthorizedHandler=(handler:()=>void)=>{unauthorizedHandler=handler;};
async function request<T>(path:string,init:RequestInit={}):Promise<ApiEnvelope<T>>{
  const token=localStorage.getItem('pintop_admin_token');
  const form=init.body instanceof FormData;
  const response=await fetch(`${baseUrl}${path}`,{...init,headers:{Accept:'application/json',...(form?{}:{'Content-Type':'application/json'}),...(token?{Authorization:`Bearer ${token}`}:{}) ,...init.headers}});
  const type=response.headers.get('content-type')||'';
  if(!type.includes('application/json')){
    if(!response.ok)throw new ApiError(`Request failed with status ${response.status}.`,response.status);
    return {success:true,message:'OK',data:await response.blob() as T};
  }
  const payload=await response.json();
  if(!response.ok){if(response.status===401)unauthorizedHandler?.();throw new ApiError(payload.message||'The request could not be completed.',response.status,payload.errors);}
  return payload as ApiEnvelope<T>;
}
export const api={
  get:<T>(path:string)=>request<T>(path),
  post:<T>(path:string,body?:unknown)=>request<T>(path,{method:'POST',body:body instanceof FormData?body:body===undefined?undefined:JSON.stringify(body)}),
  put:<T>(path:string,body?:unknown)=>request<T>(path,{method:'PUT',body:body instanceof FormData?body:JSON.stringify(body??{})}),
  patch:<T>(path:string,body?:unknown)=>request<T>(path,{method:'PATCH',body:body instanceof FormData?body:JSON.stringify(body??{})}),
  delete:<T>(path:string)=>request<T>(path,{method:'DELETE'}),
  url:(path:string)=>`${baseUrl}${path}`,
};
export function errorText(error:unknown):string{return error instanceof Error?error.message:'Something went wrong.';}
export function queryString(values:Record<string,string|number|undefined|null>):string{const p=new URLSearchParams();Object.entries(values).forEach(([k,v])=>{if(v!==undefined&&v!==null&&v!=='')p.set(k,String(v));});const q=p.toString();return q?`?${q}`:'';}
